module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/web/favicon.ico
// module id = 1065
// module chunks = 0